import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';

import PedidoService from '@/services/sit-pedidos/pedido.service';
import { Pedido, PagePedidoInput } from '@/models/sit-pedido/pedido';
import GlobalStore from '@/store/modules/global';

import { router } from '@/router';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat).locale('pt-BR');

export enum TipoDocumentoEnum {
  REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA = 'REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA',
  COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO = 'COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO',
  CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL = 'CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL',
  COPIA_CRLV = 'COPIA_CRLV',
  APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA = 'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA',
  LAUDO_TECNICO = 'LAUDO_TECNICO',
  ART = 'ART',
  //VISTORIA = "VISTORIA",
  REQUERIMENTO_TRANSPORTADORA_ASSINADO = 'REQUERIMENTO_TRANSPORTADORA_ASSINADO',
  CERTIDAO_NEGATIVA_FALENCIA = 'CERTIDAO_NEGATIVA_FALENCIA',
  BALANCO_PATRIMONIAL = 'BALANCO_PATRIMONIAL',
  //CERTIDAO_DEBITO_PECUNIARIO_DETRAN = "Certidão de inexistência de débito pecuniário Detran",
  //CERTIDAO_DEBITO_PECUNIARIO_ARCE = "Certidão de inexistência de débito pecuniário Arce",
  APOLICE_SEGURO_RESPONSABILIDADE_CIVIL = 'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL',

  CERTIDAO_NEGATIVA_DISTRIBUIDOR = 'CERTIDAO_NEGATIVA_DISTRIBUIDOR',
  CERTIDAO_INEXISTENCIA_DEBITO = 'CERTIDAO_INEXISTENCIA_DEBITO',
  APOLICE_SEGURO = 'APOLICE_SEGURO',
  CERTIDAO_NEGATIVA_ARCE = 'CERTIDAO_NEGATIVA_ARCE',

  REQUERIMENTO_APRESENTAR_CONTRATO_SOCIAL_SOCIEDADE_COMERCIAL_EPP = 'REQUERIMENTO_TRANSPORTADORA_ASSINADO',

  CONTRATO_SOCIAL = 'CONTRATO_SOCIAL',

  CERTIDAO_NEGATIVA_FEDERAL = 'CERTIDAO_NEGATIVA_FEDERAL',
  CERTIDAO_NEGATIVA_ESTADUAL = 'CERTIDAO_NEGATIVA_ESTADUAL',
  CERTIDAO_NEGATIVA_MUNICIPAL = 'CERTIDAO_NEGATIVA_MUNICIPAL',

  PROVA_INCRICAO_CADASTRO_NACIONAL_PESSOA_JURIDICA = 'PROVA_INCRICAO_CADASTRO_NACIONAL_PESSOA_JURIDICA',

  CERTIDAO_REGULAR_DA_ARCE = 'CERTIDAO_REGULAR_DA_ARCE',
  CADASTRO_NACIONAL_PESSOAS_JURIDICAS = 'CADASTRO_NACIONAL_PESSOAS_JURIDICAS',

  //FOTOS
  FOTO_DA_FRENTE_DO_VEICULO = 'FOTO_DA_FRENTE_DO_VEICULO',
  FOTO_DA_TRASEIRA_DO_VEICULO = 'FOTO_DA_TRASEIRA_DO_VEICULO',
  FOTO_LATERAL_REFERENTE_AO_LADO_DO_MOTORISTA = 'FOTO_LATERAL_REFERENTE_AO_LADO_DO_MOTORISTA',
  FOTO_LATERAL_REFERENTE_AO_LADO_DE_ENTRADA_DOS_PASSAGEIROS = 'FOTO_LATERAL_REFERENTE_AO_LADO_DE_ENTRADA_DOS_PASSAGEIROS',
  FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_PRIMEIRAS_POLTRONAS = 'FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_PRIMEIRAS_POLTRONAS',
  FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_ULTIMAS_POLTRONAS = 'FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_ULTIMAS_POLTRONAS',
  FOTO_CHASSI = 'FOTO_CHASSI',

  /// SUBSTITUIÇÃO COOPERADO
  RG = 'RG',
  CPF = 'CPF',
  CARTEIRA_RESERVISTA = 'CARTEIRA_RESERVISTA',
  COMPROVANTE_SERVICO_MILITAR = 'COMPROVANTE_SERVICO_MILITAR',
  CERTIDAO_NEGATIVA_ANT_CRIM_POLICIA_CIVIL = 'CERTIDAO_NEGATIVA_ANT_CRIM_POLICIA_CIVIL',
  COPIA_CNH_CATEGORIA_D_OU_E = 'COPIA_CNH_CATEGORIA_D_OU_E',
  CERTIDAO_NEGATIVA_ANT_CRIM_FED_MILITAR = 'CERTIDAO_NEGATIVA_ANT_CRIM_FED_MILITAR',
  CERTIDAO_NEGATIVA_ANT_CRIMINAIS_MILITAR = 'CERTIDAO_NEGATIVA_ANT_CRIMINAIS_MILITAR',
  CERTIDAO_NEGATIVA_ANT_CRIMINAIS_COMUM = 'CERTIDAO_NEGATIVA_ANT_CRIMINAIS_COMUM',
  CERTIDAO_NEGATIVA_ANT_CRIMINAIS_ELEITORAL = 'CERTIDAO_NEGATIVA_ANT_CRIMINAIS_ELEITORAL',
  CERTIDAO_NEGATIVA_ANT_CRIM_FED_COMUM = 'CERTIDAO_NEGATIVA_ANT_CRIM_FED_COMUM',
  CERTIDAO_NEGATIVA_ANT_CRIM_POLICIA_FEDERAL = 'CERTIDAO_NEGATIVA_ANT_CRIM_POLICIA_FEDERAL',
  CERTIDAO_NEGATIVA_DEBITOS_DETRAN_CE = 'CERTIDAO_NEGATIVA_DEBITOS_DETRAN_CE',
  CERTIDAO_HISTORICO_INFRACOES = 'CERTIDAO_HISTORICO_INFRACOES',
  CERTIFICADO_CURSO_CAPACITACAO_OBRIGATORIO = 'CERTIFICADO_CURSO_CAPACITACAO_OBRIGATORIO',
  COMPROVANTE_ULTIMA_ELEICAO = 'COMPROVANTE_ULTIMA_ELEICAO',
  COMPROVANTE_ENDERECO = 'COMPROVANTE_ENDERECO',
  TERMO_ANUENCIA = 'TERMO_ANUENCIA',
}

export interface VeiculoTransportadora {
  id: number;
}

export interface DocumentoAnexo {
  file: File;
  tipoDocumento: TipoDocumentoEnum;
  dataEmissao: string;
  dataValidade: string;
  orgaoExpedidor: string;
  numeroComplemento: string;
  nomeArquivo?: string;
  id?: number;
  horaVistoria?: string;
  idMunicipio?: number;
}

export interface FormRenovacaoCRLV {
  isLoading: boolean;
  currentStep: number;
  pedido: Pedido;
  documents: Array<DocumentoAnexo>;
}

export interface InputCreatePedido {
  tipoPedido: string;
  veiculoTransportadora: {
    id: number;
  };
}

@Module({
  dynamic: true,
  namespaced: true,
  name: 'renovacaoCrlv',
  store,
})
class RenovacaoCRLVModule extends VuexModule {
  form: FormRenovacaoCRLV = {
    isLoading: false,
    currentStep: 2,
    pedido: null as Pedido,
    documents: [
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.COPIA_CRLV,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: 'DETRAN',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.LAUDO_TECNICO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.ART,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: 'CREA',
        numeroComplemento: '',
      },

      //{file: null as File, tipoDocumento: TipoDocumentoEnum.VISTORIA, dataEmissao: "", dataValidade: "", orgaoExpedidor: "", numeroComplemento: ""},
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_TRANSPORTADORA_ASSINADO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_FALENCIA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.BALANCO_PATRIMONIAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      // {file: null as File, tipoDocumento: TipoDocumentoEnum.CERTIDAO_DEBITO_PECUNIARIO_DETRAN, dataEmissao: "", dataValidade: "", orgaoExpedidor: "", numeroComplemento: ""},
      // {file: null as File, tipoDocumento: TipoDocumentoEnum.CERTIDAO_DEBITO_PECUNIARIO_ARCE, dataEmissao: "", dataValidade: "", orgaoExpedidor: "", numeroComplemento: ""},
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO_RESPONSABILIDADE_CIVIL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_DISTRIBUIDOR,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_INEXISTENCIA_DEBITO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
      {
        file: null as File,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ARCE,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
      },
    ],
  };

  table = {
    header: [
      {
        text: 'Número',
        align: 'start',
        sortable: true,
        value: 'id',
      },
      {
        text: 'Veículo',
        align: 'start',
        sortable: true,
        value: 'veiculo',
      },
      {
        text: 'Tipo',
        align: 'start',
        sortable: true,
        value: 'tipoPedido',
      },
      {
        text: 'Status',
        align: 'start',
        sortable: true,
        value: 'status',
      },
      {
        text: 'Data do pedido',
        align: 'start',
        sortable: true,
        value: 'dataCriacao',
      },
      {
        text: 'Ações',
        align: 'start',
        sortable: false,
        value: 'actions',
      },
    ],
    content: [] as Array<Pedido>,
    paginate: {
      input: {
        id: null as number,
        statuses: null as Array<string>,
        tipoPedido: null as string,
        datasCriacao: null as Array<string>,
        veiculoTransportadora: {
          veiculo: {
            id: null as number,
            placa: null as string,
          },
          transportadora: {
            id: null as number,
            cnpjSemFormate: null as string,
            nomefantasia: null as string,
            razaosocial: null as string,
          },
        },
      },
      inputPage: {
        page: 1,
        size: 10,
        sort: ['id'],
        ascendingSort: false,
      },
    },
    isLoading: false,
    total: 0,
  };

  detail = {
    data: null as Pedido,
    isLoading: false,
  };

  @Action
  setFormCurrentStep(value: number): void {
    this.form.currentStep = value;
  }

  @Action
  setFormIsLoading(value: boolean): void {
    this.form.isLoading = value;
  }

  @Action
  setFormCurrentPedido(value: Pedido): void {
    this.form.pedido = value;
  }

  @Action
  createPedido(value: InputCreatePedido): void {
    this.setFormIsLoading(true);

    PedidoService.createPedido(value).subscribe(
      (res: any) => {
        this.setFormIsLoading(false);
        this.setFormCurrentPedido(res);
        this.setFormCurrentStep(2);
      },
      err => {
        this.setFormIsLoading(false);
      }
    );
  }

  @Mutation
  clearForm(): void {
    this.form = {
      isLoading: false,
      currentStep: 1,
      pedido: null as Pedido,
      documents: [
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.COPIA_CRLV,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: 'DETRAN',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.LAUDO_TECNICO,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.ART,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: 'CREA',
          numeroComplemento: '',
        },

        //{file: null as File, tipoDocumento: TipoDocumentoEnum.VISTORIA, dataEmissao: "", dataValidade: "", orgaoExpedidor: "", numeroComplemento: ""},
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_TRANSPORTADORA_ASSINADO,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_FALENCIA,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.BALANCO_PATRIMONIAL,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        // {file: null as File, tipoDocumento: TipoDocumentoEnum.CERTIDAO_DEBITO_PECUNIARIO_DETRAN, dataEmissao: "", dataValidade: "", orgaoExpedidor: "", numeroComplemento: ""},
        // {file: null as File, tipoDocumento: TipoDocumentoEnum.CERTIDAO_DEBITO_PECUNIARIO_ARCE, dataEmissao: "", dataValidade: "", orgaoExpedidor: "", numeroComplemento: ""},
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO_RESPONSABILIDADE_CIVIL,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_DISTRIBUIDOR,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.CERTIDAO_INEXISTENCIA_DEBITO,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
        {
          file: null as File,
          tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ARCE,
          dataEmissao: '',
          dataValidade: '',
          orgaoExpedidor: '',
          numeroComplemento: '',
        },
      ],
    };
  }

  @Action
  async UPLOAD_DOCUMENTOS(documents: Array<DocumentoAnexo>): Promise<any> {
    this.setFormIsLoading(true);
    try {
      const pedidoId =
        this.form.pedido && this.form.pedido.id ? this.form.pedido.id : this.detail.data.id;

      // upload REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA
      const REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA = filterPorTipoDocumento(
        documents,
        TipoDocumentoEnum.REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA
      );
      if (REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA) {
        await PedidoService.uploadDocumento(pedidoId, REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA);
      }

      // upload CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL
      const COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO = filterPorTipoDocumento(
        documents,
        TipoDocumentoEnum.COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO
      );
      if (COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO) {
        await PedidoService.uploadDocumento(pedidoId, COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO);
      }

      // upload CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL
      const CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL = filterPorTipoDocumento(
        documents,
        TipoDocumentoEnum.CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL
      );
      if (CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL) {
        await PedidoService.uploadDocumento(pedidoId, CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL);
      }

      // upload COPIA_CRLV
      const COPIA_CRLV = filterPorTipoDocumento(documents, TipoDocumentoEnum.COPIA_CRLV);
      if (COPIA_CRLV) {
        await PedidoService.uploadDocumento(pedidoId, COPIA_CRLV);
      }

      // upload APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA
      const APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA = filterPorTipoDocumento(
        documents,
        TipoDocumentoEnum.APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA
      );
      if (APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA) {
        await PedidoService.uploadDocumento(pedidoId, APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA);
      }

      // upload LAUDO_TECNICO
      const LAUDO_TECNICO = filterPorTipoDocumento(documents, TipoDocumentoEnum.LAUDO_TECNICO);
      if (LAUDO_TECNICO) {
        await PedidoService.uploadDocumento(pedidoId, LAUDO_TECNICO);
      }

      // upload ART
      const ART = filterPorTipoDocumento(documents, TipoDocumentoEnum.ART);
      if (ART) {
        await PedidoService.uploadDocumento(pedidoId, ART);
      }

      // upload VISTORIA
      // const VISTORIA = filterPorTipoDocumento(documents, TipoDocumentoEnum.VISTORIA)
      // if(VISTORIA) {
      //   await PedidoService.uploadDocumento(pedidoId, VISTORIA);
      // }

      GlobalStore.setSnackBar({
        show: true,
        message: `Arquivos adicionados com sucesso`,
        type: 'success',
      });

      this.setFormIsLoading(false);

      router.currentRoute.name === 'renovacao-registro-veiculo'
        ? router.push({
            name: 'pedidos-detail',
            params: { id: String(this.form.pedido.id) },
          })
        : this.SHOW(this.detail.data.id);
    } catch (error) {
      this.setFormIsLoading(false);
      GlobalStore.setSnackBar({
        show: true,
        message: `${error.response.data.message}`,
        type: 'warning',
      });
    }
  }

  @Action
  SEARCH(): void {
    this.table.isLoading = true;
    PedidoService.page(this.table.paginate).subscribe(
      ({ content, totalElements }) => {
        this.table.content = content;
        this.table.total = totalElements;
        this.table.isLoading = false;
      },
      error => {
        this.table.isLoading = false;
      }
    );
  }

  @Action
  CHANGE_PAGE(value: any): void {
    this.table.paginate = value;
  }

  @Action
  CLEAR(): void {
    this.table.content = [];
    this.table.total = 0;
    this.table.paginate = {
      input: {
        id: null,
        statuses: null,
        tipoPedido: null,
        datasCriacao: null,
        veiculoTransportadora: {
          veiculo: {
            id: null,
            placa: null,
          },
          transportadora: {
            id: null as number,
            cnpjSemFormate: null as string,
            nomefantasia: null as string,
            razaosocial: null as string,
          },
        },
      },
      inputPage: {
        page: 1,
        size: 10,
        sort: ['id'],
        ascendingSort: false,
      },
    };
  }

  @Action
  SHOW(value: number): void {
    this.detail.isLoading = true;
    PedidoService.show(value).subscribe(
      res => {
        this.detail.data = res;
        this.detail.isLoading = false;
      },
      error => {
        router.push({ name: 'pedidos-list' });
        this.detail.isLoading = false;
      }
    );
  }

  @Action
  CLEAR_DETAIL(): void {
    this.detail.data = null;
    this.detail.isLoading = false;
    this.clearForm();
  }

  @Action
  DOWNLOAD_DOCUMENTO_ANEXO(value: DocumentoAnexo): void {
    this.detail.isLoading = true;
    PedidoService.download(value).subscribe(
      res => {
        PedidoService.doDownloadFile(res, value.nomeArquivo);
        this.detail.isLoading = false;
      },
      error => {
        this.detail.isLoading = false;
      }
    );
  }
}

// essa função está aqui fora por conta que os comportamentos de methodos dentro da classe são específicos de @actions e @mutations
const filterPorTipoDocumento = (
  documentos: DocumentoAnexo[],
  tipoDocumento: TipoDocumentoEnum
): DocumentoAnexo => {
  return documentos
    .filter(d => d.tipoDocumento === String(tipoDocumento))
    .map(d => ({
      ...d,
      dataEmissao: d.dataEmissao
        ? dayjs(`${d.dataEmissao}`, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : '',
      dataValidade: d.dataValidade
        ? dayjs(`${d.dataValidade}`, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : '',
    }))[0];
};

export default getModule(RenovacaoCRLVModule);
